module.exports = __webpack_public_path__ + "static/mar10-3ea11baf9123abdae2ebe468064c69fc.jpeg";